import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  visibility(e) {
    e.preventDefault();

    const pass = $(e.currentTarget).closest(".js-password");
    const input = pass.find(".js-password-input");

    if (input.attr("type") === "password") {
      pass.addClass("is-visible");
      input.attr("type", "text");
      $(e.currentTarget).text("隠す");
    } else {
      pass.removeClass("is-visible");
      input.attr("type", "password");
      $(e.currentTarget).text("表示する");
    }
  }
}
